import React from 'react';
const situations = ['Spending your evenings rewriting a class plan instead of resting', 'Freezing up when a student asks something you didn\u2019t expect', 'Watching a nervous beginner not come back for a second class', 'Rebuilding sequences and scripts from zero every single week', 'Not knowing how to adapt a pose for a student with an injury or limited mobility', 'Still feeling like you\u2019re guessing, even after your certification'];
export function Recognize() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-161" data-mp="2i6gvf2p9fs25">
      <div className="mx-auto max-w-5xl" data-id="element-162" data-mp="2i930mvoohvh7">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-163" data-mp="2d6u8u2njkzgo">
          <span aria-hidden="true" data-id="element-164" data-mp="289c3em8qh2df">🧘</span> Do You Recognize Yourself in These Situations?
        </h2>
        <p className="mt-4 text-center text-base text-ink-soft sm:text-lg" data-id="element-165" data-mp="bf7mieelhsqj">
          If you can say yes to any of these — this is for you.
        </p>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="6fcyqjq49j9p">
          {situations.map((item, index) => <li key={item} className="rounded-3xl border border-sage/25 bg-cream-card p-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-167" data-mp="3nmfg7qml3t3x" data-mpi={index}>
              <span className="mb-4 flex h-8 w-8 items-center justify-center rounded-full bg-sage-tint text-sm font-bold text-teal" data-id="element-168" data-mp="39p8z00hie2gt">
                {index + 1}
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center text-base font-semibold text-terracotta sm:text-lg" data-id="element-169" data-mp="b5jyiperzvi9">
          And you deserve so much more than that. →
        </p>
      </div>
    </section>;
}